import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
const serverUrlPath = publishObjectPath.serverUrl;

export class VideoManagement {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 列表-All
  public getVideoData(opts: object) {
    const url = serverUrlPath + `/api/yunnan/external/video-point-info/list`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 列表-Page
  public getVideoPageData(opts: object) {
    const url = serverUrlPath + `/api/yunnan/external/video-point-info`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 详情
  public getVideoDetail(id: string) {
    const url = serverUrlPath + `/api/yunnan/external/video-point-info/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 新增
  public addVideo(opts: object) {
    const url = serverUrlPath + `/api/yunnan/external/video-point-info`;
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改
  public putVideo(id: string, opts: object) {
    const url = serverUrlPath + `/api/yunnan/external/video-point-info/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除
  public deleteVideo(id: string) {
    const url = serverUrlPath + `/api/yunnan/external/video-point-info/${id}`;
    return this.rSerivce.serverObj.delete(url);
  }

  // 海康区域列表
  public HKRegionList(opts: object) {
    const url = serverUrlPath + `/api/yunnan/hik-vision/region`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 海康相机列表
  public HKCameraList(opts: object) {
    const url = serverUrlPath + `/api/yunnan/hik-vision/camera`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
}
